export const authTokenPath = "auth";
export const tutorialPath = "is_tutorial_done";
